export default __webpack_public_path__ + "static/media/icon_project_construction.261b0a8f.svg";